import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; 
import axios from "axios"; // Import axios
import { baseurl, imageUrl } from "../../Baseurl"; // Assuming you have this URL defined
import { Edit, Eye } from "react-feather";
import { useParams } from "react-router-dom";
import logo from "../../component/img/logo.png"; 
import { toWords } from 'number-to-words';


const PerformaInvoiceAdmin = () => {
  const { orderId } = useParams(); // Get orderId from the URL
  const [orderData, setOrderData] = useState(null); // State to store order details
  const [loading, setLoading] = useState(true); // Loading state to show spinner or loading message
  
  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const response = await axios.get(`${baseurl}getOrderByOrderId/${orderId}`); // API call
        if (response.data.success) {
          setOrderData(response.data.order); // Set order data to state
        } else {
          console.error("Failed to fetch order details");
        }
      } catch (error) {
        console.error("Error fetching order details:", error);
      } finally {
        setLoading(false); // Set loading to false after API call completes
      }
    };

    fetchOrderDetails(); // Call function to fetch order details
  }, [orderId]); // Only re-run the effect if orderId changes

  // If loading, show a loading message or spinner
  if (loading) {
    return <div>Loading...</div>;
  }

  // If no order data, show a message
  if (!orderData) {
    return <div>No order found</div>;
  }


   // Function to format date
   const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: '2-digit', month: 'short', day: '2-digit' };
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  };

  
  // Destructure order data for convenience
  const {
    order_unique_id,
    order_status,
    order_id,
    shipping_address,
    payment_method,
    total,
    discount,
    note,
    created_at,
    cart_items
  } = orderData;


  const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  const dollarRate = parseFloat(localStorage.getItem("dollarRate")) || 1;

  const convertPrice = (inrPrice) => {
    return selectedCurrency === "USD"
      ? `$${(inrPrice / dollarRate).toFixed(2)}`
      : `₹${inrPrice}`;
  };



  const totalHalfGST = cart_items.reduce((acc, item) => {
    if (item?.gst_amount) {
      return acc + item.gst_amount / 2;
    }
    return acc;
  }, 0);


  const getAmountInWords = (amount) => {
    // Remove currency symbols and commas, and trim the result
    const cleanAmount = String(amount).replace(/[^0-9.]/g, '');
  
    const [whole, decimal] = parseFloat(cleanAmount).toFixed(2).split(".");
    const rupeesInWords = toWords(Number(whole)).toUpperCase();
    const paiseInWords = decimal !== "00" ? ` AND ${toWords(Number(decimal)).toUpperCase()}` : "";
    return `${rupeesInWords}  ${paiseInWords} ONLY`;
  };



  const totalListingPrice = cart_items.reduce((sum, item) => {
    return sum + (item?.seller_listing?.price ? Number(item.seller_listing.price) : 0);
  }, 0);


  const handlePrint = () => {
    const printContents = document.getElementById('print')?.innerHTML;
    if (printContents) {
      const originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload(); // optional, reload after print
    }
  };
  



  return (
    <>


{/* 
<div>
      <h1>Performa Invoice</h1>
      <p>Order ID: {order_unique_id}</p>
      <p>Status: {order_status}</p>
      <p>Payment Method: {payment_method}</p>
      <p>Total: {total}</p>
      <p>Discount: {discount}</p>
      <p>Note: {note}</p>

      <h3>Shipping Address</h3>
      <p>{shipping_address.full_name}</p>
      <p>{shipping_address.address_line1}, {shipping_address.city}, {shipping_address.state}, {shipping_address.country}</p>
      <p>{shipping_address.phone_number}</p>

      <h3>Cart Items</h3>
      <ul>
  {cart_items.map((item, index) => (
    <li key={index}>
      <h4>{item.title}</h4>
      <img src={`${imageUrl}/${item.image}`} alt={item.title} width="100" />
      <p>Price: {item.price} {item.currency}</p>
      <p>Quantity: {item.quantity}</p>
      <p>GST: {item.gst}%</p>
      <p>Price with GST: {item.price_with_gst}</p>
      <p>Delivery Charge: {item.delivery_charge}</p>
      <p>Total with Delivery: {item.total_with_delivery}</p>

      {item.seller_listing ? (
        <>
          <h5>Seller Listing:</h5>
          <p>Seller: {item.seller_listing.seller_id}</p>
          <p>Description: {item.seller_listing.description}</p>
          <p>Condition: {item.seller_listing.condition}</p>
          <p>Category: {item.seller_listing.category}</p>
        </>
      ) : (
        <p><em>Seller listing not available</em></p>
      )}
    </li>
  ))}
</ul>

    </div>
 */}



      <div class="invoice-container my-5" id="print">

      <div class="invoice-title">Performa Invoice</div>



        <div className="row g-0">
          <div className="col-6">
            <div class="company-info">
              <div className="d-flex">
                <div>
                  <img src={logo} className="img-fluid logoinv" />
                </div>
                <div className="text-start">
                  <h4 className="invh1">
                    Advance Research & Analytical Services
                  </h4>
                  <p className="invp">
                    1/8 South Side G.T.T. Road,
                    <br />
                    Budhansha Industrial Area, Near Aditya Business Center,
                    <br />
                    Lal Kuan, N.H-24, Ghaziabad - 201009, Uttar Pradesh
                    <br />
                    M.No: 9654360433, 432, 431
                    <br />
                    GSTIN/UIN: 09ACQPM4903Q1ZS
                    <br />
                    Email: account@arasindia.com
                  </p>
                </div>
              </div>
            </div>

            <div className="text-start px-2">
                <p className="invp">Buyer (Bill to)</p>
                <p className="invp"><strong>{shipping_address.full_name}</strong></p>
                <p className="invp">{shipping_address.phone_number}, {shipping_address.alternate_phone}</p>
              
                <p className="invp text-capitalize">{shipping_address.address_line1}</p>
                <p className="invp text-capitalize">{shipping_address.city}, &nbsp;
                 {shipping_address.state}, {shipping_address.country}, {shipping_address.postal_code}
                </p>
                <p className="invp"></p>
            </div>
          </div>
          <div className="col-6">
            <table className="table text-start">
              <tr>
                <td>
                  <div>Order Id.</div>
                  <div><strong>{order_unique_id}</strong></div>
                </td>
                <td>
                  <div>Dated</div>
                  <div><strong>{formatDate(created_at)}</strong></div>
                </td>
              </tr>

              <tr>
                <td>
                  <div>Delivery Note</div>
                  <div><strong>{note}</strong></div>
                </td>
                <td>
                  <div>Mode/Terms of Payment</div>
                  <div><strong>{payment_method}</strong></div>
                </td>
              </tr>

              <tr>
                <td colSpan={2}>
                  <div>Reference No. & Date.</div>
                  <div> </div>
                </td> 
              </tr>

              <tr>
                <td>
                  <div>Buyer's Order No.</div>
                  <div><strong>ODR_DI_{order_id}</strong></div>
                </td>
                <td>
                  <div>Dated</div>
                  <div><strong>{formatDate(created_at)}</strong></div>
                </td>
              </tr>

              {/* <tr>
                <td>
                  <div>Dispatch Doc No.</div>
                  <div>100% Advance</div>
                </td>
                <td>
                  <div>Delivery Note Date</div>
                  <div> </div>
                </td>
              </tr>  */}

              {/* <tr>
                <td>
                  <div>Dispatched through</div>
                  <div></div>
                </td>
                <td>
                  <div>Destination</div>
                  <div> </div>
                </td>
              </tr> */}

              {/* <tr>
                <td colSpan={2}>
                  <div>Terms of Delivery</div>
                  <div></div>
                </td>
                
              </tr> */}


            </table>
          </div>
        </div>

         

        

 
        <table class="product-table">
          <thead>
            <tr>
              <th>Sl No.</th>
              <th>Description of Goods</th>
              <th>Quantity</th>
              <th>Rate</th>
              <th>Per</th>
              <th>GST/Tax</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody className="remove-border">

          {cart_items.map((item, index) => (
  <tr key={index}>
    <td>{index + 1}</td>
    <td>
      <img
        src={`${imageUrl}listing/${item.image}`}
        alt={item.title}
        width="40"
        className="rounded"
      />
      <br />
      {item.seller_listing ? (
        <>
          {item.seller_listing.title}
          <br />
          CGST {item.seller_listing.gst / 2}% / SGST {item.seller_listing.gst / 2}%
        </>
      ) : (
        <em>Seller data missing</em>
      )}
    </td>
    <td>{item.quantity}</td>
    <td>{item.seller_listing ? convertPrice(item.seller_listing.price) : '-'}</td>
    <td>{item.seller_listing ? `1 ${item.seller_listing.listingstandard}` : '-'}</td>
    <td>{convertPrice(item.gst_amount)}</td>
    <td>{convertPrice(item.price)}</td>
  </tr>
))}
 
       <tr>
  <td></td>
  <td className="text-end">Central GST</td>
  <td></td>
  <td></td>
  <td></td>
  <td></td>
  <td className="text-end">(+) {convertPrice(totalHalfGST)}</td>
</tr>

<tr>
  <td></td>
  <td className="text-end">State GST</td>
  <td></td>
  <td></td>
  <td></td>
  <td></td>
  <td className="text-end">(+) {convertPrice(totalHalfGST)}</td>
</tr>

            
          </tbody>
          <tfoot className="add-border">

          <tr>
              <td></td>
              <td className="text-end">
              <strong>Discount</strong>
              </td>
              <td><strong> </strong></td>
              <td> </td>
              <td> </td>
              <td> </td>
              <td><strong>(-) {convertPrice(discount)}</strong></td>
            </tr>

          <tr>
              <td></td>
              <td className="text-end">
              <strong>Total</strong>
              </td>
              <td><strong> </strong></td>
              <td> </td>
              <td> </td>
              <td> </td>
              <td><strong>{convertPrice(total)}</strong></td>
            </tr>
          </tfoot>
        </table>

       

  <div className="amount-in-words text-start px-2 bdrinv">
  <p><strong>Amount Chargeable (in words):</strong></p>
  <p><strong>{getAmountInWords(convertPrice(total))}</strong></p>
</div>


        <table class="product-table"> 
           

            <tr>
              <td  >HSN/SAC</td>
              <td >Taxable Value </td>
              <td >CGST</td>
              <td >SGST/UTGST</td>
              <td  >Total Tax Amount</td> 
            </tr>

           


            <tr>  
              <td> {cart_items.map((item, index) => (
  <span key={index}>{item.seller_listing ?  (item.seller_listing.hsn) : '-'},</span>
))}</td>

<td>{convertPrice(totalListingPrice)}</td>

               
              <td>{convertPrice(totalHalfGST)}</td> 
               
              <td>{convertPrice(totalHalfGST)}</td> 
              <td>{convertPrice(totalHalfGST * 2)}</td> 
            </tr>

{/* 
            <tr className="text-end">  
              <td><strong>Total</strong></td>
              <td><strong>10,000.00</strong></td>
              <td></td>
              <td><strong>900.00</strong></td>
              <td></td>
              <td><strong>900.00</strong></td>
              <td><strong>1,800.00</strong></td>
            </tr>  */}
        </table>

        <p class="amount-in-words text-start px-2 bdrinv">
            <p>Tax Amount (in words): <strong> {getAmountInWords(convertPrice(totalHalfGST * 2))}</strong>
           </p>
             
           
        </p>

        <div class="footer">
          <div class="company-bank-details">
            <strong>Company's Bank Details:</strong>
            <br />
            <strong>Bank Name:</strong> State Bank of India
            <br />
            <strong>A/c Holder's Name:</strong> Advance Research & Analytical
            Services
            <br />
            <strong>A/c No.:</strong> 33753345478
            <br />
            <strong>Branch & IFS Code:</strong> BSR Industrial Area &
            SBIN0003111
          </div>
          <div class="signature">
            <p>For Advance Research & Analytical Services</p>
            <p>Authorised Signatory</p>
          </div>
        </div>
      </div>



<div className="mb-4">
<button onClick={() => window.print()} className="btn btn-primary me-2">Print</button> 

</div>



    </>
  );
};

export default PerformaInvoiceAdmin;
